export default __webpack_public_path__ + "static/media/showcase-disabilities.608ca540.jpg";